export default __webpack_public_path__ + "static/media/social.sprite.1267cce442af3ea9b1b6ca672349b980.svg";